import { jsx as _jsx } from "react/jsx-runtime";
import { StyledHubspotDynamicFormIframeComponent } from "./hubspot-dynamic-form-iframe-component.scss";
import ContactSalesHubspotFormComponent from "../side-by-side-hubspot-form/components/contact-sales-hubspot-form-component";
const HubspotDynamicFormIframeComponent = (props)=>{
    const { formId, urlToRedirectAfterSubmission, source, withPrivacyNotice, formMinHeight, formWidth, backgroundColor, textColor, textSize, ctaButtonColor, ctaTextColor, formShadow, useNewBaseForm, dontRenderPostFormSubmit } = props;
    return /*#__PURE__*/ _jsx(StyledHubspotDynamicFormIframeComponent, {
        className: "hubspot-dynamic-form-iframe-component",
        formWidth: formWidth,
        children: /*#__PURE__*/ _jsx(ContactSalesHubspotFormComponent, {
            formId: formId,
            formMinHeight: formMinHeight,
            source: source,
            withPrivacyNotice: withPrivacyNotice,
            urlToRedirectAfterSubmission: urlToRedirectAfterSubmission,
            backgroundColor: backgroundColor,
            textColor: textColor,
            textSize: textSize,
            ctaButtonColor: ctaButtonColor,
            ctaTextColor: ctaTextColor,
            formShadow: formShadow,
            useNewBaseForm: useNewBaseForm,
            dontRenderPostFormSubmit: dontRenderPostFormSubmit
        })
    });
};
HubspotDynamicFormIframeComponent.defaultProps = {
    formId: "706f2f71-b48f-4dde-850f-055f5e3664d2"
};
export default HubspotDynamicFormIframeComponent;
